import { Webhooks } from "../../../shared/Webhooks/Webhooks";

export const CopilotApiWebhooks = () => <Webhooks />;
